import { Component } from '@angular/core';
import { PillarPagesTemp } from "../../components/pillar-pages-temp/pillar-pages-temp";

@Component({
  selector: 'app-credentials-value',
  imports: [PillarPagesTemp],
  templateUrl: './credentials-value.html',
  styleUrl: './credentials-value.scss',
})
export class CredentialsValue {

}
